import axios from "axios";
import store from "@/store";
import router from "@/router";
import { Message } from 'element-ui';
import { ensureVisitor } from "@/utils/uuid_token";
// console.log("process.env", process.env);
// console.log("process.env.VUE_APP_API", process.env.VUE_APP_API);
const instance = axios.create({
    baseURL: process.env.VUE_APP_API,
    headers: { 'content-type': 'application/x-www-form-urlencoded' }
})
// 添加请求拦截器
instance.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
    if (config.method === 'get') {
        config.headers['Cache-Control'] = 'max-age=100'
    }
    if (localStorage.getItem("token")) {
        config.headers["Authorization"] = localStorage.getItem("token")
    } else {
        config.headers["Authorization"] = localStorage.getItem("uuidtoken")

    }
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

// 添加响应拦截器
instance.interceptors.response.use(function (response) {
    // 2xx 范围内的状态码都会触发该函数。
    // 对响应数据做点什么
    if (response.status === 200) {
        if (response.data.code == 1001) {
            if (localStorage.getItem("token")) {
                // 真实用户：登录过期/失效 → 清 token、提示并去登录
                localStorage.removeItem("token");
                store.dispatch('login')
                setTimeout(() => {
                    Message({
                        message: 'The login expired or invalid',
                        type: 'error',
                        duration: 2000,
                        onClose: () => {
                            //此处写提示关闭后需要执行的函数
                            router.replace({
                                path: '/login',
                                query: { redirect: router.currentRoute.fullPath }
                            })
                        }
                    })
                }, 50);
            } else {
                // 游客：访客会话失效 → 静默重建，不打断浏览
                localStorage.removeItem("uuidtoken");
                ensureVisitor().then(() => store.dispatch('login'))
            }
        }
        // 无论是否 1001 都返回信封(code/data/msg)，保持响应形状一致，
        // 让调用点用 res.code!=200 兜底，避免把 undefined 喂进 .then 导致崩溃
        return response.data;
    }
    return response;
}, function (error) {
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    if ([401, 403].includes(error.status)) {
        // 无访问权限，可能情况有
        // 401:没传token或者使用伪造的token
        // 403:访客越权访问用户服务
        router.replace('/login')
    }
    return Promise.reject(error);
});
export default instance;